import { render, staticRenderFns } from "./ItemPage.vue?vue&type=template&id=6d444a16&scoped=true&"
import script from "./ItemPage.vue?vue&type=script&lang=js&"
export * from "./ItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ItemPage.vue?vue&type=style&index=0&id=6d444a16&scoped=true&lang=css&"
import style1 from "./ItemPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d444a16",
  null
  
)

export default component.exports